/**
 * API link.
 */
export const API_URL = 'https://geoloc.test.fonroche-lighting.com/v1/';

/**
 * API route for operations.
 */
export const API_URL_OPERATION = API_URL + 'operation';

/**
 * API route for authentication.
 */
export const URL_API_AUTH = API_URL + 'auth/login/operator';
